/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetAnnotationsQueryResponse, FilesControllerGetAnnotationsPathParams } from "../../models/filesController/FilesControllerGetAnnotations";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetAnnotations } from "../../clients/filesService/filesControllerGetAnnotations";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetAnnotationsQueryKey = (id: FilesControllerGetAnnotationsPathParams["id"]) => [{
  url: '/api/v1/files/:id/annotations',
  params: {
    id: id
  }
}] as const;
export type FilesControllerGetAnnotationsQueryKey = ReturnType<typeof filesControllerGetAnnotationsQueryKey>;
export function filesControllerGetAnnotationsQueryOptions(id: FilesControllerGetAnnotationsPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetAnnotationsQueryKey(id);
  return queryOptions<FilesControllerGetAnnotationsQueryResponse, ResponseErrorConfig<Error>, FilesControllerGetAnnotationsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetAnnotations(id, config);
    }
  });
}

/**
 * @description Returns all annotations (notes and markups) for the specified file as JSON array. Used by PDF export to generate Markups table.
 * @summary Get file annotations
 * {@link /api/v1/files/:id/annotations}
 */
export function useFilesControllerGetAnnotations<TData = FilesControllerGetAnnotationsQueryResponse, TQueryData = FilesControllerGetAnnotationsQueryResponse, TQueryKey extends QueryKey = FilesControllerGetAnnotationsQueryKey>(id: FilesControllerGetAnnotationsPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetAnnotationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetAnnotationsQueryKey(id);
  const query = useQuery({
    ...filesControllerGetAnnotationsQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}